import React from "react";
import { BaseLayout } from "../components/baseLayout";
import { ListAssistants } from "../components/listAssistants";

function Rate() {
  return (
    <BaseLayout>
            <ListAssistants />
    </BaseLayout>
  );
}

export { Rate };
